<script lang="ts" setup>
import type { Context } from '../../types/content'
import { useContextsStore } from '../stores/contexts'

const { context } = defineProps<{
  context: Context
}>()

const emit = defineEmits<{
  (e: 'open', contextId: string): void
  (e: 'end'): void
}>()

const contextsStore = useContextsStore()

const contextName = computed({
  get() {
    return context.name
  },
  set(value: string) {
    if (value === context.name) return
    contextsStore.updateContext({ id: context.id, name: value })
  }
})

function handleSelectColor(color: string) {
  contextsStore.updateContext({ id: context.id, color })
}

function handleStopEditing() {
  emit('end')
}
</script>

<template>
  <li class="flex items-center gap-2">
    <UPopover>
      <button
        class="p-2 rounded-3xl w-10 h-10"
        type="button"
        :style="{
          backgroundColor: `var(--color-context-${context.color})`
        }"
        @click.stop
      />
      <template #content>
        <ContextColorPicker @select="handleSelectColor" />
      </template>
    </UPopover>
    <UInput
      v-model="contextName"
      class="flex-1"
      type="text"
      size="xl"
      autofocus
      :maxlength="32"
      @keydown.enter.stop="handleStopEditing"
      @keydown.esc.stop="handleStopEditing"
    />
    <UButton
      variant="ghost"
      color="neutral"
      icon="i-mingcute-check-line"
      @click="handleStopEditing"
    />
  </li>
</template>
